import { type FC, type ReactNode } from "react";

export const PanelControls: FC<{
  children: ReactNode;
}> = ({ children }) => <div className="flex gap-4">{children}</div>;
